import React, { Children } from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  stars: '⭐️⭐️⭐️⭐️⭐️',
  text: 'Dejamos de discutir todos los días. Ahora hay reglas claras y menos tensión.',
  author: 'María, mamá de un niño de ocho años.'
}, {
  stars: '⭐️⭐️⭐️⭐️⭐️',
  text: 'Pensé que iba a ser teoría, pero son acciones reales. Cambió la dinámica en casa.',
  author: 'Lucas, papá de dos hijos.'
}, {
  stars: '⭐️⭐️⭐️⭐️⭐️',
  text: 'Mi hijo duerme mejor y volvimos a compartir tiempo juntos.',
  author: 'Ana.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const bubbleVariants = {
  hidden: {
    opacity: 0,
    y: 20,
    scale: 0.95
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: 'easeOut'
    }
  }
};
export function Testimonials() {
  return <section className="w-full bg-light-gray py-16 px-6" data-id="element-69">
      <div className="max-w-2xl mx-auto" data-id="element-70">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="font-playfair text-2xl md:text-3xl font-semibold text-dark-text mb-10 text-center" data-id="element-71">
          Lo que dicen otros padres
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-4" data-id="element-72">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={bubbleVariants} className="bg-white rounded-2xl rounded-tl-sm p-5 shadow-md max-w-[90%]" data-id="element-73">
              <p className="text-sm mb-2" data-id="element-74">{testimonial.stars}</p>
              <p className="font-lato text-base text-dark-text mb-3" data-id="element-75">
                "{testimonial.text}"
              </p>
              <p className="font-lato text-sm text-medium-text" data-id="element-76">
                — {testimonial.author}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}